import React from 'react';

function InventoryReports() {
  return <div className="text-2xl font-bold">InventoryReports</div>;
}

export default InventoryReports;
